module.exports = __webpack_public_path__ + "static/media/bookingsbanner.67a237dc.svg";